import styled from '@emotion/styled'

export const ModalContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`
